import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdsProvider } from '@search/ads';
import { useBrandConfiguration } from '@search/core/brands/context';
import { useConsent } from '@search/core/hooks/useConsent';
import { AppProvider } from '@search/serp_common/contexts/AppContext';
import { createLogger } from '@search/serp_common/helpers/createLogger';
import { useInitSerpData } from '@search/serp_common/hooks/useInitSerpData';
import { AppWithProviders } from './AppWithProviders';
import { appConfig } from './config/appConfig';
export const GONE_410 = '410 - Gone';
export const PERMANENT_REDIRECT_308 = '308 - Permanent Redirect';
export const InnerApp = () => {
    const { brand } = useBrandConfiguration();
    const logger = createLogger('app_serp');
    const consent = useConsent();
    const { data, error } = useInitSerpData(appConfig);
    // Log potential useFetcher errors
    if (error) {
        logger.error(`[SERP - InnerApp useFetcher error: ${error?.message}`, { error });
    }
    if (data) {
        // Handle SEO Gone & permanentRedirect status codes on SSR.
        if ('seoInitialProps' in data) {
            if ('gone' in data.seoInitialProps)
                return _jsx(_Fragment, { children: GONE_410 });
            if ('permanentRedirect' in data.seoInitialProps)
                return _jsx(_Fragment, { children: PERMANENT_REDIRECT_308 });
        }
        if ('pageProps' in data) {
            const isSeo = !!data.pageProps.seoModel;
            // If seo robots is provided use it, if not (technical url) use default instead (noindex, nofollow)
            if (!data.headInfos.robots)
                data.headInfos.robots = isSeo ? 'nofollow' : 'noindex, nofollow';
            return (_jsx(AppProvider, { ...data.pageProps, children: _jsx(AdsProvider, { initialSearchModel: data?.pageProps?.searchModel, initialAdsSearchModel: data.pageProps?.pageData, consent: consent, brand: brand, children: _jsx(AppWithProviders, { headInfosProps: data.headInfos }) }) }));
        }
    }
    // should never happen
    return _jsx(_Fragment, {});
};
